import type { SVGProps } from 'react';

export const BusinessIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    {...props}
  >
    <path
      fill="currentColor"
      d="M4 21c-.55 0-1.02-.196-1.412-.587A1.927 1.927 0 0 1 2 19V5c0-.55.196-1.021.588-1.413A1.925 1.925 0 0 1 4 3h6c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v2h8c.55 0 1.021.196 1.413.587.391.392.587.863.587 1.413v10c0 .55-.196 1.021-.587 1.413A1.928 1.928 0 0 1 20 21H4Zm0-2h6v-2H4v2Zm0-4h6v-2H4v2Zm0-4h6V9H4v2Zm0-4h6V5H4v2Zm8 12h8V9h-8v10Zm2-6v-2h4v2h-4Zm0 4v-2h4v2h-4Z"
    />
  </svg>
);
